import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { TransactionsData } from "types/models/master/MasterApp";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  minWidth:170,
  "&:first-of-type": {
    paddingLeft: 20,
  },
  "&:last-of-type": {
    paddingRight: 20,
  },
}));

interface TableItemProps {
  data: TransactionsData;
}


const TableItem: React.FC<TableItemProps> = ({ data }) => {   
const getStatusColor = () => {
    switch (data.status) {
      case "Pending": {
        return "#43C888";
      }
      default: {
        return "#E2A72E";
      }
    }
  };
  return (
    <TableRow key={data.orderId} className="item-hover">
      <StyledTableCell component="th" scope="row">
        <Box
          sx={{
            color: "black", 
            borderBottom: "none",
            display: "inline-block",
          }}
        >
          {data.orderId}
        </Box>
      </StyledTableCell>
    
      <StyledTableCell align="left">{data.txnId}</StyledTableCell>
      <StyledTableCell align="left">{data.txndate}</StyledTableCell>
      <StyledTableCell align="left">{data.custId}</StyledTableCell>
      <StyledTableCell align="left">{data.name}</StyledTableCell>
      <StyledTableCell align="left">{data.rmn}</StyledTableCell>
      <StyledTableCell align="left">{data.type}</StyledTableCell>
      <StyledTableCell align="left">{data.resMsg}</StyledTableCell>
      <StyledTableCell align="left">{data.wallet}</StyledTableCell>
      <StyledTableCell align="left">{data.refNo}</StyledTableCell>
      <StyledTableCell align="center">{data.amount}</StyledTableCell>

      <StyledTableCell align="right">
       <Box
          sx={{
            color: getStatusColor(),
            backgroundColor: getStatusColor() + "44",
            padding: "3px 5px",
            borderRadius: 1,
            fontSize: 14,
            display: "inline-block",
            minWidth: 80,
            textAlign: "center",
          }}
        >
          {data.status}
        </Box>
      </StyledTableCell>
    </TableRow>
  );
};

export default TableItem;
